import React from 'react';
import './Cards.css';
import CardItem from './CardItem';
import {
  centralHeatingPng as imgCentralHeating,
  poolHeatingPng as imgPoolHeating,
  domesticHotWaterPng as imgDomesticHotWater,
  solarWaterHeatingPng as imgSolarWaterHeating,
} from '../images/assets';

function Cards() {
  return (
    <div className='cards'>
      <h1 style={{fontWeight:'bolder', fontSize:28}}>Services</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src={imgCentralHeating}
              text='Central Heating'
              path='/central-heating'
            />
            <CardItem
              src={imgPoolHeating}
              text='Pool Heating'
              path='/pool-heating'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src={imgDomesticHotWater}
              text='Domestic Hot Water'
              path='/domesticHotWater'
            />
            <CardItem
              src={imgSolarWaterHeating}
              text='Solar Water Heating'
              path='/solar-waterHeating'
            />
            
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;
